export default {
  dairyV2: process.env.REACT_APP_FEATURE_FLAG_DAIRY_V2 === "true",
  poultryProcessingForInterventions:
    process.env.REACT_APP_FEATURE_FLAG_POULTY_PROCESSING_FOR_INTERVENTIONS ===
    "true",
  cloudWatchRUM: process.env.REACT_APP_FEATURE_FLAG_CLOUD_WATCH_RUM === "true",
  feedV2Routing: process.env.REACT_APP_FEATURE_FLAG_FEED_V2_ROUTING === "true",
  farmV2Routing: process.env.REACT_APP_FEATURE_FLAG_FARM_V2_ROUTING === "true",
  shrimpInterventions:
    process.env.REACT_APP_FEATURE_FLAG_SHRIMP_INTERVENTIONS === "true",
  dairyInterventions:
    process.env.REACT_APP_FEATURE_FLAG_DAIRY_INTERVENTIONS === "true",
  beefInterventions:
    process.env.REACT_APP_FEATURE_FLAG_BEEF_INTERVENTIONS === "true",
  databaseGFLI_2_2:
    process.env.REACT_APP_FEATURE_FLAG_DATABASE_GFLI_2_2 === "true",
  shrimpProcessing:
    process.env.REACT_APP_FEATURE_FLAG_SHRIMP_PROCESSING === "true",
  beefContinousGrowingChanges:
    process.env.REACT_APP_FEATURE_FLAG_BEEF_CONTINUOUS_GROWING_CHANGES ===
    "true",
  authentication: process.env.REACT_APP_FEATURE_FLAG_AUTHENTICATION === "true",
  FLAGReporting: process.env.REACT_APP_FEATURE_FLAG_FLAG_REPORTING === "true",
  nutritionalMarineFish:
    process.env.REACT_APP_FEATURE_FLAG_NUTRITIONAL_MARINE_FISH === "true",
  FlagCoreConnectAPI:
    process.env.REACT_APP_FEATURE_FLAG_CORE_CONNECT_INTEGRATION === "true",
  organizationCoreConnect:
    process.env.REACT_APP_FF_ORGANIZATION_CORE_CONNECT === "true",
  deprecateAFP5: process.env.REACT_APP_FEATURE_FLAG_DEPRECATE_AFP5 === "true",
  pigFLAGReporting: process.env.REACT_APP_FEATURE_FLAG_FLAG_PIG === "true",
  shrimpFLAGReporting:
    process.env.REACT_APP_FEATURE_FLAG_FLAG_SHRIMP === "true",
  dairyFLAGReporting: process.env.REACT_APP_FEATURE_FLAG_FLAG_DAIRY === "true",
  beefFLAGReporting: process.env.REACT_APP_FEATURE_FLAG_FLAG_BEEF === "true",
  marineFishFLAGReporting:
    process.env.REACT_APP_FEATURE_FLAG_FLAG_MARINE_FISH === "true",
  gfli3: process.env.REACT_APP_FEATURE_FLAG_GFLI3 === "true",
  homepageFP: process.env.REACT_APP_FEATURE_FLAG_HOMEPAGE_FP === "true",
  databaseConversion:
    process.env.REACT_APP_FEATURE_FLAG_DATABASE_CONVERSION === "true",
  notifications: process.env.REACT_APP_FEATURE_FLAG_NOTIFICATIONS === "true",
  warmupFpPerformance:
    process.env.REACT_APP_FEATURE_FLAG_WARMUP_FP_PERFORMANCE === "true",
  woodchips: process.env.REACT_APP_FEATURE_FLAG_WOODCHIPS === "true",
  lpgUnit: process.env.REACT_APP_FEATURE_FLAG_LPG_UNIT === "true",
  ffBugsQ3s1: process.env.REACT_APP_FEATURE_FLAG_FF_BUGS_Q3S1 === "true",
  roiCalculatorPoultry:
    process.env.REACT_APP_FEATURE_FLAG_ROI_CALCULATOR_POULTRY === "true",
  roiCalculatorPig:
    process.env.REACT_APP_FEATURE_FLAG_ROI_CALCULATOR_PIG === "true",
  ffBugsQ3s1Partner:
    process.env.REACT_APP_FEATURE_FLAG_FF_BUGS_Q3S1_PARTNER === "true",
  ingredientsCropCoreConnect:
    process.env.REACT_APP_FF_INGREDIENTS_CROP_CORECONNECT === "true",
  partnerApiV2: process.env.REACT_APP_FEATURE_FLAG_PARTNER_API_V2 === "true",
  partnerApiFarmLock:
    process.env.REACT_APP_FEATURE_FLAG_PARTNER_API_FARM_LOCK === "true",
  backofficeM1: process.env.REACT_APP_FF_BACKOFFICE_M1 === "true",
};
